import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Keys } from '@ps-gui/shared-core';
import { WordRect } from '../page-overlay/model';
import { SelectionMode } from '../model/ocr-selection-model';

export interface OcrSelection {
  words: string[];
  wordRects: WordRect[];
  pageId: string;
  mode: SelectionMode;
}

@Injectable({
  providedIn: 'root',
})
export class OcrSelectionService {
  selections: Subject<OcrSelection> = new Subject<OcrSelection>();

  newSelection(words: string[], wordRects: WordRect[], pageId: string) {
    const mode: SelectionMode = Keys.Control.isPressed() ? 'append' : 'replace';
    this.selections.next({ words, wordRects, mode, pageId });
  }
}
